'use client';

import { createContext, useEffect, useState } from 'react';

import { IPageContext } from './';

export const PageContext = createContext<IPageContext>({
  language: 'en',
  country: 'GB',
  locale: 'en-GB',
  locales: ['en-GB'],
  defaultLocale: 'en-GB',
  preview: false,
  previewData: null,
});

export function PageContextProvider(props) {
  const {
    preview,
    previewData,
    language,
    country,
    locales,
    locale,
    defaultLocale,
    children,
  } = props;
  const [context, setContext] = useState({
    language,
    country,
    locales,
    locale,
    defaultLocale,
    preview,
    previewData,
  });
  useEffect(() => {
    setContext({
      language,
      country,
      locales,
      locale,
      defaultLocale,
      preview,
      previewData,
    });
  }, [preview, previewData, language, country, locales, locale, defaultLocale]);
  return (
    <PageContext.Provider value={context}>{children}</PageContext.Provider>
  );
}
